import type { UseSortParams } from '../../../../components/SearchPage/components/Sort/Sort.typed';

const useSort = (params: UseSortParams) => {
  const { updateURL, selected, sortFields } = params;
  const [fallbackOption] = sortFields;

  const displayLabel =
    sortFields.find(({ name }) => name === selected)?.displayName ??
    fallbackOption.displayName;

  const items = sortFields.map(({ name, displayName }) => ({
    name,
    displayName,
    selected: name === selected,
    dataTracking: `sort-${displayName}`,
  }));

  const selectSort = (name: string) => {
    updateURL({ queryParams: { sort: name } });
  };

  return { displayLabel, items, selectSort };
};

export { useSort };
